export default "__VITE_ASSET__KhmkROxj__"